<template lang="pug">
.sticky.z-index-10.ui-bright
  .ui-design__container.transparent.py-10.px-2.mx-auto.d-flex.align-center.gap-16
    layout-header-navigation.flex-1
    layout-header-notifications
    layout-header-user-data

</template>

<script>
import LayoutHeaderNavigation from './LayoutHeaderNavigation.vue';
import LayoutHeaderUserData from './LayoutHeaderUserData.vue';
import LayoutHeaderNotifications from './LayoutHeaderNotifications.vue';

export default {
  components: {
    LayoutHeaderNavigation,
    LayoutHeaderUserData,
    LayoutHeaderNotifications,
  },
  props: {},
  computed: {},
};
</script>
